var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#79BF5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9981 19.2346C11.1203 19.2259 9.70045 18.6601 8.41722 17.6906C7.51092 17.0059 6.84934 16.1424 6.42828 15.0905C6.39726 15.013 6.35914 14.9371 6.33921 14.8568C6.28781 14.6494 6.34726 14.4775 6.5549 14.4024C6.75273 14.3309 6.92563 14.3864 7.01818 14.5917C7.20515 15.0061 7.39415 15.4157 7.64474 15.8006C8.15019 16.5771 8.84887 17.1302 9.62434 17.6012C10.3777 18.0588 11.1972 18.3665 12.0672 18.4693C12.7212 18.5466 13.3899 18.5226 14.0386 18.3449C15.3223 17.9934 16.4406 17.3633 17.3515 16.3823C17.7669 15.9348 18.0835 15.425 18.3113 14.8592C18.3355 14.799 18.3561 14.737 18.385 14.6792C18.5188 14.4115 18.685 14.3248 18.8881 14.4134C19.0978 14.5049 19.1791 14.7218 19.0768 14.9833C18.7898 15.7167 18.3863 16.3791 17.8471 16.9568C17.0175 17.8455 16.0176 18.478 14.8754 18.8712C14.1908 19.1069 13.4836 19.2783 12.9981 19.2346Z",
    fill: "#1C5B01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02369 10.4571C9.02414 11.1999 8.50472 11.7286 7.77362 11.7297C7.04634 11.7307 6.4901 11.1907 6.49072 10.4841C6.49134 9.76089 7.03716 9.19899 7.74276 9.19542C8.45715 9.19178 9.02324 9.7494 9.02369 10.4571Z",
    fill: "#1D5B00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9315 10.468C19.0095 11.1487 18.3414 11.7572 17.6843 11.7421C16.9578 11.7254 16.4429 11.1615 16.4071 10.4922C16.3699 9.7973 16.988 9.18971 17.6864 9.19799C18.3774 9.20616 18.9913 9.72588 18.9315 10.468Z",
    fill: "#1D5B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellent);
export default __webpack_public_path__ + "static/media/excellent.f9165274771293a9dbb9095d7b12d49b.svg";
export { ForwardRef as ReactComponent };